var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isEmailVerified && !_vm.isNewsletterAbo && !_vm.hadNewsletterOnce)?_c('ModalNewsletterConfirm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }